import airPLS from 'ml-airpls';
import baselineRegression from 'ml-baseline-correction-regression';
import { xyEquallySpaced } from 'ml-spectra-processing';
export const id = 'baselineCorrection';
export const name = 'Baseline correction';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: false,
    updateYDomain: false,
};
export function apply(datum1D, options) {
    if (!isApplicable(datum1D)) {
        throw new Error('baselineCorrection not applicable on this data');
    }
    const { algorithm } = options;
    const { x, re } = datum1D.data;
    let corrected;
    switch (algorithm) {
        case 'airpls':
            corrected = airPLS(x, re, options).corrected;
            break;
        case 'polynomial':
            {
                const { degree, zones } = options;
                const reduced = xyEquallySpaced({ x, y: re }, { numberOfPoints: 4096, zones });
                const result = baselineRegression(reduced.x, reduced.y, {
                    regressionOptions: degree,
                });
                const { regression } = result;
                corrected = new Float64Array(x.length);
                for (let i = 0; i < re.length; i++) {
                    corrected[i] = re[i] - regression.predict(x[i]);
                }
            }
            break;
        default:
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            throw new Error(`baselineCorrection: algorithm unknown: ${algorithm}`);
    }
    Object.assign(datum1D.data, { re: corrected });
}
export function isApplicable(datum1D) {
    if (!datum1D.info.isFid)
        return true;
    return false;
}
export function reduce(previousValue, newValue) {
    return {
        once: true,
        reduce: newValue,
    };
}
//# sourceMappingURL=baselineCorrection.js.map